// PSW (marketing website) home URL. Falls back to the RO-specific
// NEXT_PUBLIC_PROVIDENT_SANITY_WEBSITE_URL (same value, to be retired) so RO
// works with the existing variable groups, then to '/' when neither is set.
export const CMS_URL =
  process.env.NEXT_PUBLIC_CMS_URL ||
  process.env.NEXT_PUBLIC_PROVIDENT_SANITY_WEBSITE_URL ||
  '/';
